import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=9c913e5c&"
import script from "YD/components/Feedback.component.js?vue&type=script&lang=js&"
export * from "YD/components/Feedback.component.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports